import { CssBaseline, ThemeProvider } from '@mui/material'
import type { FC } from 'react'
import { Outlet } from 'react-router-dom'
import NavBar from './NavBar'
import { theme } from './theme'

const Layout: FC = () => {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <NavBar />
      <Outlet />
    </ThemeProvider>
  )
}

export default Layout
